import React from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { transformViewDate } from "utils/date-utils";
import { getExamNoteCreatorName } from "./helper";
import LastExamNotesModal from "./LastExamNotesModal";

import useStyles from "./styles";

const LAST_EXAM_NOTE_LIMIT = 90;
const LAST_EXAM_NOTES_HISTORY_MIN = 1;

interface IProps {
  horse: racehorse360.IHorse;
}

const LastExamNote = (props: IProps) => {
  const { horse } = props;
  const classes = useStyles();
  const shouldHistoryShow =
    horse.completedExamsWithNoteCount > LAST_EXAM_NOTES_HISTORY_MIN;
  const note = horse.lastExamNote.note;

  const noteCreator = getExamNoteCreatorName(horse.lastExamNote.createdBy);

  const noteDate = transformViewDate(
    horse.lastExamNote.createdOn,
    null,
    "MM/dd/yy h:mm a"
  );

  const noteContent =
    note.length > LAST_EXAM_NOTE_LIMIT
      ? `${note.slice(0, LAST_EXAM_NOTE_LIMIT)}...`
      : note;

  return (
    <>
      {Boolean(note) && (
        <div className={classes.lastExamNoteContainer}>
          <div className={classes.lastExamNoteHeader}>
            {"Last Exam Note"}
            {shouldHistoryShow && <LastExamNotesModal horse={horse} />}
            <span className={classes.margin}>{noteCreator}</span>
            <span className={classes.margin}>{noteDate}</span>
          </div>
          <div>{noteContent}</div>
        </div>
      )}
    </>
  );
};

export default React.memo(LastExamNote);
